import React from 'react';
import { MediaResponse } from '../../types/api/common';

interface MediaPreviewProps {
    images: MediaResponse[];
    className?: string;
}

const MediaPreview: React.FC<MediaPreviewProps> = ({ images, className = '' }) => {
    const handleImageClick = (image: MediaResponse) => {
        const imageUrl = image.file || image.preview;
        window.open(imageUrl, '_blank');
    };

    if (!images || images.length === 0) {
        return null;
    }

    return (
        <div className={`flex flex-wrap gap-2 ${className}`}>
            {images.map((image) => (
                <div
                    className="bg-header border border-border rounded-md flex-shrink-0 hover:cursor-pointer"
                    key={image.id}
                    onClick={(e) => {
                        e.stopPropagation();
                        handleImageClick(image);
                    }}
                    style={{
                        backgroundImage: `url("${image.preview}")`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        width: "80px",
                        height: "80px"
                    }}
                />
            ))}
        </div>
    );
};

export default MediaPreview;